import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import {HTTP, AUTH} from '@/script/http-common'
import jwt_decode from 'jwt-decode'
// var _ = require('lodash');

// function compareArray (otherArray, field='id'){
//   return function(current){
//     return otherArray.filter(function(other){
//       return other[field] == current[field]
//     }).length == 0;
//   }
// }

// async function asyncForEach(array, callback) {
//   for (let index = 0; index < array.length; index++) {
//     await callback(array[index], index, array);
//   }
// }

/* eslint-disable no-console */
export default new Vuex.Store({
  state: {
    jwt: {
      access: localStorage.getItem('accessToken'),
      refresh: localStorage.getItem('refreshToken'),
    },
    userProfile: {},
  },

  getters: {
    jwtAccessValid: state => () => {     
      let expAccess = (state.jwt.access) ? jwt_decode(state.jwt.access).exp : 0
      return (expAccess - Date.now()/1000 > 0) ? true : false
    },

    jwtAccess: state => () => {
      let expAccess = (state.jwt.access) ? jwt_decode(state.jwt.access).exp : 0
      return (expAccess - Date.now()/1000 > 0) ? state.jwt.access : null      
    },

    userProfile: state => {
      return state.userProfile
    },

    userName: state => {
      let username = false
      if (Object.keys(state.userProfile).length !== 0) {
        username = (state.userProfile.name) ? state.userProfile.name : state.userProfile.user
      }
      return username
    },
  },

  mutations: {
    updateToken: (state, newToken) => {
      localStorage.setItem('accessToken', newToken.access);
      localStorage.setItem('refreshToken', newToken.refresh);
      state.jwt = newToken;
      console.log('token updated')
    },
    
    removeToken: (state) => {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      state.jwt.access = null
      state.jwt.refresh = null
    },

    SETuserProfile: (state, userProfile) => {
      console.log('userProfile', userProfile)
      state.userProfile = userProfile
    },
  },

  actions: {
    FETCHproducts: async ({getters, commit, dispatch}, ) => {
      let response = await HTTP(getters.jwtAccess()).get('product/')
      let propducts_id = response.data.map(item => item.id);
      commit('SETproducts', response.data)
      await dispatch('FETCHpropType', [propducts_id])
      await dispatch('FETCHspecType', [propducts_id])
    },

    obtainToken: async ({commit, dispatch}, {username, password}) => {
      const payload = {
        username: username,
        password: password
      }
      var success
      try {
        let response = await AUTH.post('create/', payload)
        if (response.status >= 200 && response.status < 300) {
          commit('updateToken', response.data)
          await dispatch('FETCHuserProfile')
          success = true
        }
      } catch(error){
        console.log(error.response)
        success = false
      }
      return success
    },
    
    refreshToken: async ({state, commit}) => {
      const payload = {
        refresh: state.jwt.refresh
      }
      var success
      try {  
        let response = await AUTH.post('refresh/', payload)
        if (response.status >= 200 && response.status < 300) {
          commit('updateToken', response.data)
          success = true
        }
      } catch (error){
        success = false
      }
      return success
    },

    inspectToken: async({state, dispatch}) => {
      var success = true
      let expDelay = 900 // 15min
      let expAccess = (state.jwt.access) ? jwt_decode(state.jwt.access).exp : 0
      console.log('----------------------------------------')
      if (expAccess - Date.now()/1000 <= expDelay) {
        console.log('Need updateToken')
        success = (state.jwt.refresh) ? await dispatch('refreshToken') : false
      }
      return success
    },

    FETCHuserProfile: async({getters, commit, dispatch}) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      try {
        let response = await HTTP(getters.jwtAccess()).get(`profile/`)
        commit('SETuserProfile', response.data[0])
      } catch(error){
        console.log(error.response)
      }
    },

  }
})
